export default "__VITE_ASSET__8fa7ad19__"